/**
 * Returns how much in percent a child container overlaps container that is
 * treated as a viewport
 * @param  {Object} viewportDimentions
 * @param  {Object} coordinates
 * @param  {Number} [whitespaceModifier=1]
 * @return [Number]
 */
export function countPercentOfContainerInZoom(
  viewportDimentions,
  coordinates,
  whitespaceModifier = 1
) {
  let intersection = {};
  intersection.left = Math.max(viewportDimentions.left, coordinates.left);
  intersection.right = Math.min(viewportDimentions.right, coordinates.right);
  intersection.top = Math.max(viewportDimentions.top, coordinates.top);
  intersection.bottom = Math.min(viewportDimentions.bottom, coordinates.bottom);
  intersection.width = Math.max(0, intersection.right - intersection.left);
  intersection.height = Math.max(0, intersection.bottom - intersection.top);
  intersection.area = intersection.width * intersection.height;
  const viewportArea = viewportDimentions.surfaceArea * whitespaceModifier;
  const percentageInView = 100 * Math.min(1, intersection.area / viewportArea);
  return percentageInView;
}

/**
 * Returns percentage in view for articles and page when
 * we are in double page mode but we see only one page. For this case, when the page
 * is not zoomed, page should always get 100% and articles get defaultPercentageInView * 2
 * @param  {object} page
 * @return {object} percentageInView object
 */
export function getPercentInViewForSinglePage(page) {
  if (!page || !page.content) return;
  const percentageInView = page.content.reduce((obj, article) => {
    obj[`article_${article.ContentID}`] = article.defaultPercentageInView;
    return obj;
  }, {});
  percentageInView[`page_${page.PublicationPageID}`] = 100;
  return percentageInView;
}



// WEBPACK FOOTER //
// ./src/common/utilities/percentageInViewUtils.js